const init_customer = {
  name: {
    value: "",
    label: "Name",
    placeholder: "Enter Customer Name",
  },
  company_name: {
    value: "",
    label: "Company Name",
    placeholder: "Enter Company Name",
  },
  email: {
    value: "",
    label: "Email",
    placeholder: "Enter Email Address",
  },
  phone_no: {
    value: "",
    label: "Phone Number",
    placeholder: "Enter Phone Number",
  },
  address: {
    value: "",
    label: "Address",
    placeholder: "Enter Address",
  },
};

export default init_customer;
